<template lang="pug">
v-bottom-nav(:active.sync="bottomNav" :value="true" app color="white")
  v-btn(value="summary" flat color="accent" exact)
    span {{ $t('text.summaryTabs.detail') }}
    v-icon(v-text="$vuetify.icons.themeResult")
  v-btn(v-show="bottomNavInputWords" value="inputWords" flat color="accent")
    span {{ $t('text.summaryTabs.inputWords') }}
    v-icon(v-text="$vuetify.icons.answerItem")
  v-btn(value="answeredUsers" flat color="accent")
    span {{ $t('text.summaryTabs.answeredUsers') }}
    v-icon(v-text="$vuetify.icons.users")
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('matching', [
      'bottomNavInputWords',
    ]),
    bottomNav: {
      get () {
        return this.$store.state.matching.bottomNav
      },
      set (value) {
        this.$store.commit('matching/setBottomNav', value)
      }
    },
  },
  beforeDestroy () {
    this.bottomNav = 'summary'
  },
}
</script>
